import { FormControl, FormGroup } from '@angular/forms';
import { QuestionAnswerRequest } from '@shared/models/question-answer-request';
import { Question } from '@shared/models/views-models/question-view';

export function getNumberOfCharactersInString(inputString: string): number {
  return [...new Intl.Segmenter().segment(inputString)].length;
}

export function utf8ByteCount(text: string): number {
  return new TextEncoder().encode(text).length;
}

export function addResponseIdToAnswers(
  responseId: string,
  answers: QuestionAnswerRequest[],
): QuestionAnswerRequest[] {
  answers.forEach((answer) => {
    answer.responseId = responseId;
  });
  return answers;
}

export const validateAllFormFields = (formGroup: FormGroup) => {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);

    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
      control.updateValueAndValidity();
    } else if (control instanceof FormGroup) {
      control.markAsTouched();
      validateAllFormFields(control);
    }
  });
};

export const getFormGroup = (
  questionId: string,
  form: FormGroup,
): FormGroup => {
  return form.get(questionId) as FormGroup;
};

export const findQuestionById = (
  questionId: string,
  questions: Question[],
): Question | undefined => {
  for (const question of questions) {
    if (question.id === questionId) {
      return question;
    }
    if (question.type === 'MATRIX') {
      const found = question.rows.find((row) => row.id === questionId);
      if (found) {
        return found;
      }
    }
    if (question.type === 'MULTI_MATRIX') {
      const found = question.columns
        .flatMap((column) => column.rows)
        .find((row) => row.id === questionId);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
};
